import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";

import CardPodiumTable from "../../components/general/CardPodiumTable";

export class PodiumTab extends Component {
  render() {
    return (
      <Row>
        <Col xs={12} md={6}>
          <div ref={this.refPrintExpertG}>
            <CardPodiumTable
              title={`Experts performance globale ${this.props.date}`}
              isLoad={this.props.isLoadExpert}
              data={this.props.perfExpert}
              format="currency"
              length={6}
              isColor={true}
            />
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div ref={this.refPrintExpertCA}>
            <CardPodiumTable
              title={`Experts performance CA ${this.props.date}`}
              isLoad={this.props.isLoadExpert}
              data={this.props.caExpert}
              format="currency"
              length={6}
              isColor={true}
            />
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div ref={this.refPrintAgencyG}>
            <CardPodiumTable
              title={`Agences performance globale ${this.props.date}`}
              isLoad={this.props.isLoadAgency}
              data={this.props.perfAgency}
              format="currency"
              length={6}
              isColor={true}
            />
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div ref={this.refPrintAgencyCA}>
            <CardPodiumTable
              title={`Agences performance CA ${this.props.date}`}
              isLoad={this.props.isLoadAgency}
              data={this.props.caAgency}
              format="currency"
              length={6}
              isColor={true}
            />
          </div>
        </Col>
        {this.props.group === 1 ? (
          <>
            <Col xs={12} md={6}>
              <CardPodiumTable
                title={`Agences performance RSE ${this.props.date}`}
                isLoad={this.props.isLoadAgency}
                data={this.props.perfRSEAgency}
                format="currency"
                length={6}
                isColor={true}
              />
            </Col>
            <Col xs={12} md={6}>
              <CardPodiumTable
                title={`Experts performance RSE ${this.props.date}`}
                isLoad={this.props.isLoadExpert}
                data={this.props.perfRSE}
                format="currency"
                length={6}
                isColor={true}
              />
            </Col>
          </>
        ) : null}
      </Row>
    );
  }
}
